import React, { useState, useEffect } from "react";

const UsuarioForm = ({ onSubmit, initialData,resetForm  }) => {
    const [formData, setFormData] = useState({
        nombre: "",
        correo: "",
        contrasena: "",
        tipo_usuario: "alumno",
    });

    useEffect(() => {
        if (initialData) {
            setFormData(initialData);
        } else if (resetForm) {
            setFormData({
                nombre: "",
                correo: "",
                contrasena: "",
                tipo_usuario: "alumno",
            });
        }
    }, [initialData, resetForm]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    return (
        <div className="container mt-5">
            <h2 className="mb-4">Formulario de Usuario</h2>
            <form onSubmit={handleSubmit} className="p-3 border rounded bg-light">
                <div className="row">
                    <div className="col-md-6 mb-3">
                        <label htmlFor="nombre" className="form-label">Nombre:</label>
                        <input
                            type="text"
                            id="nombre"
                            name="nombre"
                            className="form-control"
                            value={formData.nombre}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label htmlFor="correo" className="form-label">Correo:</label>
                        <input
                            type="email"
                            id="correo"
                            name="correo"
                            className="form-control"
                            value={formData.correo}
                            onChange={handleChange}
                            required
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6 mb-3">
                        <label htmlFor="contrasena" className="form-label">Contraseña:</label>
                        <input
                            type="password"
                            id="contrasena"
                            name="contrasena"
                            className="form-control"
                            value={formData.contrasena}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label htmlFor="tipo_usuario" className="form-label">Tipo de Usuario:</label>
                        <select
                            id="tipo_usuario"
                            name="tipo_usuario"
                            className="form-control"
                            value={formData.tipo_usuario}
                            onChange={handleChange}
                        >
                            <option value="admin">Admin</option>
                            <option value="maestro">Maestro</option>
                            <option value="padre">Padre</option>
                            <option value="alumno">Alumno</option>
                        </select>
                    </div>
                </div>
                <div className="text-center">
                    <button type="submit" className="btn btn-primary">Guardar</button>
                </div>
            </form>
        </div>);
};

export default UsuarioForm;
